//Import required modules
import React from 'react';
import PropTypes from 'prop-types'

//Import Components
import UserCircle from './UserCircle';

//UserRow Component
const UserRow = ({userArr}, {store}) =>
{
    let userWindow = store.getState().userWindow;
    return (
    <div>
        <div style={{width: userWindow.rowWidth,
                    height: userWindow.rowHeight-10}}>
                <svg style={{width: userWindow.rowWidth,
                            height: userWindow.rowHeight}}>
                    <g transform="translate(0,0)">
                        {
                        userArr.map((d, i) => <UserCircle key={i} 
                                                            {...d}/>)
                        }
                    </g>
                </svg>
        </div>
        <hr className={`${store.getState().theme}`}/>
    </div>
    )
}

UserRow.contextTypes = {
    store: PropTypes.object
}

export default UserRow;